import React from 'react';
import {GoCheck, GoDash} from 'react-icons/go';
import { InputCheckboxWrapper, InputCheckboxSkin } from './styles';

/**
 * Returns the checkbox on create account
 *
 * @param xmargin - The margin from the text
 * @param onClick - The on click event
 * @param checked - The status of the checkbox
 * @param icon - The icon of the input
 * @returns The checkbox component
 */

export default ({
  xmargin = '0 12px 0 0',
  onClick,
  checked,
  icon,
  id
}: {
  xmargin?: string;
  onClick?: any;
  checked?: boolean;
  icon?: string;
  id?: string;
}) => (
  <InputCheckboxWrapper xmargin={xmargin}>
    <input type="checkbox" id={id} checked={checked} onClick={onClick} readOnly />
    <InputCheckboxSkin>{icon === 'line' ? <GoDash color="#FFF" /> : <GoCheck color="#FFF" />}</InputCheckboxSkin>
  </InputCheckboxWrapper>
);
